import React from 'react';
import { coreDomains } from '../data/corporateData';
import { Users, Film, Clapperboard, TrendingUp, Globe, Lightbulb, ArrowUpRight } from 'lucide-react';

const iconMap = {
  Users: Users,
  Film: Film,
  Clapperboard: Clapperboard,
  TrendingUp: TrendingUp,
  Globe: Globe,
  Lightbulb: Lightbulb
};

const CoreDomains = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0A192F]" id="domains">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="mb-12 max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
            Strategic Capabilities
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
            Core Domains of Expertise
          </h2>
          <p className="text-base text-slate-300 leading-relaxed font-body">
            Six strategic pillars driving business transformation across the entertainment ecosystem
          </p>
        </div>

        {/* Domains Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="core-domains-grid">
          {coreDomains.map((domain) => {
            const IconComponent = iconMap[domain.icon];
            return (
              <div
                key={domain.id}
                className="group bg-[#112240] border border-white/10 rounded-lg p-6 hover:border-rose-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-rose-500/10"
                data-testid={`domain-card-${domain.id}`}
              >
                {/* Icon */}
                <div className="mb-4 flex items-center justify-between">
                  <div className="w-12 h-12 bg-rose-500/10 rounded-lg flex items-center justify-center group-hover:bg-rose-500/20 transition-colors duration-300">
                    <IconComponent className="text-rose-500" size={24} />
                  </div>
                  <ArrowUpRight className="text-slate-500 group-hover:text-rose-500 transition-colors duration-300" size={20} />
                </div>

                {/* Title */}
                <h3 className="text-xl sm:text-2xl font-semibold text-slate-100 mb-3 font-heading">
                  {domain.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-slate-400 mb-4 font-body leading-relaxed">
                  {domain.description}
                </p>

                {/* Highlights */}
                <ul className="space-y-2">
                  {domain.highlights.map((highlight, index) => (
                    <li 
                      key={index} 
                      className="text-xs text-slate-300 flex items-start gap-2 font-body"
                    >
                      <span className="text-rose-500 mt-1">•</span>
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreDomains;
